export default function Footer() {
  return (
    <footer className="relative py-12 overflow-hidden border-t border-white/10">
      {/* Background Image with Overlay - Same as Hero */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1e5214669b52b106ad5d4fd45ca37d70.jpg"
          alt="Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="text-center">
          {/* Logo Badge - Same style as Hero */}
          <div className="flex justify-center mb-6">
            <div className="bg-gradient-to-r from-indigo-500/20 to-purple-500/20 backdrop-blur-xl border border-white/30 rounded-full px-4 py-2 shadow-2xl">
              <span className="text-base font-bold bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent whitespace-nowrap">
                Steel Importações 🇺🇸
              </span>
            </div>
          </div>

          {/* Copyright */}
          <p className="text-gray-400 text-sm mb-4">
            © {new Date().getFullYear()} Steel Importações. Todos os direitos reservados.
          </p>

          {/* Readdy Link */}
          <div className="flex justify-center">
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-indigo-400 text-xs transition-colors duration-300 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
